exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hos-info-name{border-bottom:.026667rem solid #d7d7d7;margin:1rem}.hospital-content{margin-left:4%;position:relative;width:92%;overflow-y:auto;height:70%;text-align:left}.hos-hint{color:#aaa;margin-top:-.533333rem;margin-left:.586667rem}#color-input-red+label{display:block;width:.533333rem;height:.533333rem;border-radius:.133333rem;top:.053333rem;left:.4rem;background:#aaa}#color-input-red:checked+label:before{display:block;content:\"\\2714\";text-align:center;font-size:.426667rem;color:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d01fe16e","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/registeredPrompt/registeredPrompt.vue
// module id = 486
// module chunks = 0